export enum FeatureToggle {
  oauthApplications = 'rt_oauth_applications',
}
